/*
 * @Descripttion: 首页顶部 Tab 的「保留哪些 + 顺序」配置
 * @version:
 * @Author: geory
 * @Date: 2026-01-13 00:00:00
 * @LastEditors: geory
 * @LastEditTime: 2026-01-13 00:00:00
 */

/**
 * 首页(Home.vue)顶部页签的配置，首页和设置页共用这一份：
 *   - 首页：顶栏按这份配置渲染；长按拖动排序后回写
 *   - 设置页「首页页签」：勾选要保留的、上下箭头调顺序
 * 两边各写一份默认值很容易走偏（改了默认顺序只改一边），所以统一抽到这里。
 *
 * 存储位置（读的时候按优先级取，写的时候两个都写）：
 *   1) settingInfo.homeTopTabs —— 主进程持久化 + 广播给各窗口 + 随其它设置一起云端同步（首选）
 *   2) localStorage `wminput:topTabOrder` —— 老版本「长按拖动排序」留下的配置；
 *      没有 Electron（浏览器里跑）时也只有这一份
 */

export const HOME_TOP_TAB_STORAGE_KEY = "wminput:topTabOrder";

// 默认页签，数组顺序即默认顺序。
// type=normal 的用 index 对应 Home 里的 tabIndex；xiaoguan（销冠键盘）是独立页签，没有 tabIndex。
export const HOME_TOP_TAB_DEFAULTS = [
  { key: "huashu", label: "共享话术", type: "normal", index: 0 },
  { key: "wenan", label: "文案库", type: "normal", index: 1 },
  { key: "xiaoguan", label: "销冠键盘", type: "xiaoguan" },
  { key: "memo", label: "备忘提醒", type: "normal", index: 2 },
  { key: "clipboard", label: "剪贴板", type: "normal", index: 3 },
  { key: "skill", label: "Skill", type: "normal", index: 4 },
];

// 默认配置（带 visible，给设置页的列表用）
export function defaultHomeTabListWithVisible() {
  return HOME_TOP_TAB_DEFAULTS.map(function (tab) {
    return Object.assign({}, tab, { visible: true });
  });
}

export function defaultHomeTopTabs() {
  return HOME_TOP_TAB_DEFAULTS.map(function (tab) {
    return Object.assign({}, tab);
  });
}

export function defaultHomeTopTabKeys() {
  return HOME_TOP_TAB_DEFAULTS.map(function (tab) {
    return tab.key;
  });
}

function tabByKey(key) {
  for (let i = 0; i < HOME_TOP_TAB_DEFAULTS.length; i++) {
    if (HOME_TOP_TAB_DEFAULTS[i].key === key) return HOME_TOP_TAB_DEFAULTS[i];
  }
  return null;
}

/**
 * 把任意历史格式归一化成「要保留的页签对象数组」（顺序保留）：
 *   ["wenan","huashu"] / [{key:"wenan"},...] / 带已下线页签 / 有重复项 都能吃下。
 * 归一化后为空（没配置过、配置损坏、浏览器数据被清）→ 回退成默认（即全部保留）。
 * 注：不允许「一个都不保留」，首页内容区完全没法用。
 */
export function normalizeHomeTopTabs(raw) {
  const list = [];
  const seen = {};
  if (Array.isArray(raw)) {
    raw.forEach(function (item) {
      const key = typeof item === "string" ? item : item && item.key;
      if (!key || seen[key]) return;
      const def = tabByKey(key);
      if (!def) return;
      seen[key] = true;
      list.push(Object.assign({}, def));
    });
  }
  return list.length ? list : defaultHomeTopTabs();
}

// 读取设置项里的配置。没这一项返回 null（区别于「配置成空数组」），
// 让上层能决定是否回退到本地缓存 —— 老用户升级上来时设置项里还没有这一项。
export function homeTabsFromSettingInfo(info) {
  if (!info || !Array.isArray(info.homeTopTabs)) return null;
  return normalizeHomeTopTabs(info.homeTopTabs);
}

// 读取老版本（长按拖动排序）写在 localStorage 里的配置；没配置过返回 null
export function loadLocalHomeTopTabs() {
  try {
    const raw = localStorage.getItem(HOME_TOP_TAB_STORAGE_KEY);
    if (!raw) return null;
    return normalizeHomeTopTabs(JSON.parse(raw));
  } catch (e) {
    return null;
  }
}

export function saveLocalHomeTopTabs(tabs) {
  try {
    const keys = (tabs || [])
      .map(function (tab) {
        return typeof tab === "string" ? tab : tab && tab.key;
      })
      .filter(Boolean);
    localStorage.setItem(HOME_TOP_TAB_STORAGE_KEY, JSON.stringify(keys));
  } catch (e) {}
}

export function clearLocalHomeTopTabs() {
  try {
    localStorage.removeItem(HOME_TOP_TAB_STORAGE_KEY);
  } catch (e) {}
}
